<template lang="pug">
    .pagination-wrapper.container
        router-link(
            v-if="youngerRoute"
            :to="youngerRoute"
        )
            //- | nächster Beitrag
            | &#171; Beitrag
            span.other-post {{ younger.title }}
            | lesen
        .spacer(v-else)
        router-link(
            v-if="olderRoute"
            :to="olderRoute"
        )
            //- | älterer Beitrag &#187;
            | Beitrag
            span.other-post {{ older.title }}
            | lesen &#187;
        .spacer(v-else)
</template>
<script>
import { get } from 'lodash'
import { mapGetters } from 'vuex'

export default {
    name: "CategoryPagination",
    components: {
        // Component
    },
    props: {
        older: {
            type: [Object, null]
        },
        younger: {
            type: [Object, null]
        }
    },
    computed: {
        origin() {
            return this.$route.query.origin
        },
        youngerRoute() {
            if (this.younger === null || this.younger === undefined) return false
            // const categoryKey = get(this.younger, 'category.key')
            // const key = this.younger.key

            // let categoryPath
            // switch (categoryKey) {
            //     case 'news':
            //         categoryPath = `/aktuelles/${key}`
            //         break;

            //     case 'press':
            //         categoryPath = `/presse/${key}`
            //         break;

            //     default:
            //         categoryPath = `/${categoryKey}/${key}`
            //         break;
            // }

            // return categoryPath

            let categoryKey = get(this.younger, 'category.key')
            const key = this.younger.key

            // let categoryPath
            switch (categoryKey) {
                case 'news':
                    // categoryPath = `/aktuelles/${key}`
                    categoryKey = 'aktuelles';
                    break;

                case 'press':
                    // categoryPath = `/presse/${key}`
                    categoryKey = 'presse';
                    break;
            }

            let route = {
                name: categoryKey,
                params: { key },
            }

            if (this.origin) {
                route.query = { origin: this.origin }
            }

            let src
            const referencedPost = get(this.younger, 'category.cms.id') !== this.cms.id
            if (referencedPost) src = get(this.younger, 'category.cms.id')
            // else src = get(this.reference, 'menuItem.menu.cms.id')
            if (src) route.params.src = src

            return route
        },
        olderRoute() {
            if (this.older === null || this.older === undefined) return false
            // const categoryKey = get(this.older, 'category.key')
            // const key = this.older.key

            // let categoryPath
            // switch (categoryKey) {
            //     case 'news':
            //         categoryPath = `/aktuelles/${key}`
            //         break;

            //     case 'press':
            //         categoryPath = `/presse/${key}`
            //         break;

            //     default:
            //         categoryPath = `/${categoryKey}/${key}`
            //         break;
            // }

            // return categoryPath

            let categoryKey = get(this.older, 'category.key')
            const key = this.older.key

            // let categoryPath
            switch (categoryKey) {
                case 'news':
                    // categoryPath = `/aktuelles/${key}`
                    categoryKey = 'aktuelles';
                    break;
                case 'stellenanzeigen':
                    // categoryPath = `/presse/${key}`
                    categoryKey = 'stellenanzeigen';
                    break;

                case 'press':
                    // categoryPath = `/presse/${key}`
                    categoryKey = 'presse';
                    break;
            }

            let route = {
                name: categoryKey,
                params: { key },
            }

            if (this.origin) {
                route.query = { origin: this.origin }
            }

            let src
            const referencedPost = get(this.older, 'category.cms.id') !== this.cms.id
            if (referencedPost) src = get(this.older, 'category.cms.id')
            // else src = get(this.reference, 'menuItem.menu.cms.id')
            if (src) route.params.src = src

            return route
        },
        ...mapGetters( {
            reference: 'currentPage/reference',
            cms: 'CMS',
        })
    },
}
</script>
<style lang="sass" scoped>
@import '~@/assets/sass/variables'

.pagination-wrapper
    padding: 2rem
    display: flex
    flex-direction: row
    justify-content: space-between
    a
        color: #aaa
        &:hover
            color: $primary
        .other-post
            color: $primary
            font-weight: bold
            &::before,
            &::after
                content: ' '
</style>
